import React from 'react';
import PropTypes from 'prop-types';

const styles = {
    itemInformacoesInscricao: {
        marginLeft: 10,
        borderRadius: 5,
        color: '#FFF',
    },
};

const ItemInformacoesInscricao = ({ cor, texto }) => {
    const splitTexto = () => texto.split(' ').join('').toLowerCase();

    return (
        <span style={{ ...styles.itemInformacoesInscricao, ...{ backgroundColor: cor } }}>
            &nbsp;#{splitTexto()}&nbsp;
        </span>
    );
};

ItemInformacoesInscricao.propTypes = {
    cor: PropTypes.string.isRequired,
    texto: PropTypes.string.isRequired,
};

export default ItemInformacoesInscricao;
